import { render } from "./PanelistsPage.vue?vue&type=template&id=db94fa20&ts=true"
import script from "./PanelistsPage.vue?vue&type=script&lang=ts"
export * from "./PanelistsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__